import { Box, type BoxProps, styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  height: ${rem(190)};
  background: ${(props) => props.theme.palette.primary.light};
  justify-content: center;
  align-items: center;

  ${(props) => props.theme.breakpoints.down("sm")} {
    height: ${rem(100)};
  }
`;

const CardTitle = styled("h3")`
  font-size: ${rem(24)};
  font-weight: 500;
  color: ${(props) => props.theme.palette.secondary.main};
`;

type CardProps = BoxProps & {
  isTitle?: boolean;
};

export const Card = ({ children, isTitle, ...boxProps }: CardProps) => {
  return (
    <StyledBox {...boxProps} role="presentation">
      {isTitle ? <CardTitle>{children}</CardTitle> : children}
    </StyledBox>
  );
};
